import React, { useMemo } from 'react';
import { gql } from '@apollo/client';
import { compact } from '@moda/portal-stanchions';
import { LookType, LookRecommendationFragment } from '../../generated/types';
import { VARIANT_CELL_FRAGMENT } from '../Grid/GridCell/VariantCell/VariantCell';
import { EnableLazyLoad } from '../LazyLoad';
import { DIVIDER_LAYOUT_TYPES } from '../DividerPumoModule';
import { RecommendationsCarousel } from '../RecommendationsPumoModule';

export const LOOK_RECOMMENDATION_FRAGMENT = gql`
  fragment LookRecommendationFragment on Look {
    id
    lookType: look_type
    title
    description
    variants {
      edges {
        node {
          canSell: can_sell
          ...VariantCellFragment
        }
      }
    }
  }
  ${VARIANT_CELL_FRAGMENT}
`;

type Props = {
  variantId: string;
  look: LookRecommendationFragment;
};

export const LookRecommendation: React.FC<Props> = ({
  variantId,
  look: { id, lookType, title, description, variants }
}) => {
  const cells = useMemo(
    () =>
      compact(variants?.edges?.map(edge => edge?.node)).filter(
        variant =>
          (variant.id !== variantId || lookType === LookType.complete_the_routine) &&
          variant.canSell
      ),
    [variants, variantId, lookType]
  );

  return (
    <EnableLazyLoad>
      <RecommendationsCarousel
        identifier={`LookRecommendation-${id}`}
        divider={{
          layoutType: DIVIDER_LAYOUT_TYPES.ONE_LINE,
          text: title
        }}
        description={description}
        cells={cells}
        enableAddSetToBag={lookType === LookType.complete_the_routine}
      />
    </EnableLazyLoad>
  );
};
